import { Component, Input } from '@angular/core';
@Component({
  selector: 'fgb-portal-games-banner',
  templateUrl: './portal-games-banner.component.html',
  styleUrl: './portal-games-banner.component.scss',
})
export class PortalGamesBannerComponent {
  @Input() isTriviaPage: boolean = false;
  @Input() isPollsPage: boolean = false;
  @Input() isPredictorPage: boolean = false;
  @Input() showFooter: boolean = false;
}
